import update from 'immutability-helper'
/**
 * 修改 image box config
 */
export function updateImageBox(node: any, action) {
  const { key, value, index } = action
  if (index < 0) {
    return node
  }
  if (key === '') {
    // delete
    node = update(node, {
      config: {
        images: {
          $splice: [[index, 1]],
        },
      },
    })
  } else if (!node.config.images || index >= node.config.images.length) {
    // add
    node = update(node, {
      config: {
        images: {
          $apply: (images?: Array<any>) => {
            return update(images || [], {
              $push: [
                {
                  [key]: value,
                },
              ],
            })
          },
        },
      },
    })
  } else {
    // update
    node = update(node, {
      config: {
        images: {
          [index]: {
            [key]: {
              $set: value,
            },
          },
        },
      },
    })
  }
  return node
}

export function updateImageRes(node: any, action: any) {
  if (!action.fileList) {
    return node
  }

  return update(node, {
    config: {
      images: {
        $set: action.fileList,
      },
    },
  })
}

// 更新基础配置信息
export function setImgConfig(node, action) {
  return update(node, {
    config: {
      [action.key]: {
        $set: action.value,
      },
    },
  })
}
